export default from './environment-provider';



// WEBPACK FOOTER //
// ./app/components/environment-provider/index.js